<style></style>
<template><portal-403/></template>
<script>export default {}
</script>



// WEBPACK FOOTER //
// src/pages/403.vue